/**
 * KROQ — pages saisonnières.
 *
 * Deux responsabilités, aucune dépendance :
 *   1. suivi du contexte de campagne — uniquement du contexte, jamais un
 *      doublon des événements standard Shopify (product_viewed,
 *      product_added_to_cart, checkout_started existent déjà et sont
 *      dédupliqués côté Shopify) ;
 *   2. chargement à la demande des clips « porté par la meute ».
 *
 * Charge utile volontairement minimale : season_id, product_handle,
 * placement, offer_id. Aucune donnée du chien ne transite ici.
 */
(function () {
  'use strict';

  /** Émet un événement de contexte vers les puits déjà en place. */
  function suivre(nom, charge) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(nom, charge);
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', nom.replace(/:/g, '_'));
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: nom }, charge));
      }
    } catch (e) {
      /* le suivi ne doit jamais casser la page */
    }
  }

  function saisonDe(el) {
    const hote = el.closest('[data-season]');
    return hote ? hote.getAttribute('data-season') : null;
  }

  function init() {
    const racines = document.querySelectorAll('[data-kroq-season]');
    if (racines.length) {
      suivre('kroq_seasonal_view', {
        season_id: racines[0].getAttribute('data-kroq-season'),
      });
    }

    document.addEventListener('click', function (e) {
      const prod = e.target.closest('[data-kroq-season-produit]');
      if (prod) {
        suivre('kroq_seasonal_product_click', {
          season_id: saisonDe(prod),
          product_handle: prod.getAttribute('data-kroq-season-produit'),
          placement: prod.getAttribute('data-kroq-season-placement') || 'inconnu',
        });
        return;
      }
      const offre = e.target.closest('[data-kroq-season-offre]');
      if (offre) {
        suivre('kroq_seasonal_offer_click', {
          season_id: saisonDe(offre),
          offer_id: offre.getAttribute('data-kroq-season-offre'),
        });
      }
    });

    // ── clips : la source n'est posée qu'à l'approche de l'écran
    const clips = document.querySelectorAll('[data-kroq-ugc-src]');
    if (!clips.length) return;

    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');

    function activer(video) {
      if (video.dataset.pret === 'oui') return;
      video.dataset.pret = 'oui';
      const src = video.getAttribute('data-kroq-ugc-src');
      if (!src) return;
      const s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      video.appendChild(s);
      video.load();
      // Muette et sans son : le navigateur autorise la lecture. Sous
      // reduced-motion on s'arrête au poster.
      if (!reduit.matches) {
        const essai = video.play();
        if (essai && typeof essai.catch === 'function') essai.catch(function () {});
      }
    }

    if (!('IntersectionObserver' in window)) {
      clips.forEach(activer);
      return;
    }
    const obs = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          activer(e.target);
          obs.unobserve(e.target);
        });
      },
      { rootMargin: '300px' }
    );
    clips.forEach(function (c) { obs.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
